import * as THREE from 'three';
import { createExplosion } from './effects.js';

const laserBox = new THREE.Box3();
const sleighBox = new THREE.Box3();
const sbBox = new THREE.Box3();
const presentBox = new THREE.Box3();

export function handleLasers(lasers, snowballs, scene, game, deltaTime) {
    for (let i = lasers.length - 1; i >= 0; i--) {
        const laser = lasers[i];
        laser.position.x += 5 * deltaTime;
        if (laser.position.x > 10) {
            scene.remove(laser);
            lasers.splice(i, 1);
            continue;
        }

        laserBox.setFromObject(laser);
        for (let j = snowballs.length - 1; j >= 0; j--) {
            const snowball = snowballs[j];
            sbBox.setFromObject(snowball);
            if (laserBox.intersectsBox(sbBox)) {
                createExplosion(scene, snowball.position.clone(), game.explosionMaterial);

                // Update snowball hit counter
                game.snowballsHit += 1;
                game.updateSnowballsUI();

                snowball.position.x = Math.random() * 10 + 15;
                snowball.position.y = Math.random() * 4.5 - 1.25;

                scene.remove(laser);
                lasers.splice(i, 1);

                game.handleSnowballHitByLaser();
                break; 
            }
        }
    }
}

export function handleSleighCollisions(sleighObject, snowballs, presents, onSnowballCollision, onPresentCollision, scene, explosionMaterial, game) {
    if (!sleighObject) return;

    sleighBox.setFromObject(sleighObject);

    // Snowball collision
    for (const snowball of snowballs) {
        sbBox.setFromObject(snowball);
        if (sleighBox.intersectsBox(sbBox)) {
    
            createExplosion(scene, snowball.position.clone(), explosionMaterial);

            if (typeof onSnowballCollision === 'function') {
            onSnowballCollision();
            }

            if(game) {
                game.handleSnowballCollision();
            }

            resetSnowball(snowball);
        }
    }

    // Present Collision
    for (const present of presents) {
        presentBox.setFromObject(present);
        if (sleighBox.intersectsBox(presentBox)) {
            if (typeof onPresentCollision === 'function') {
                onPresentCollision();
            }
            if(game) {
                game.handlePresentCollision();
            }
            scene.remove(present);
            const index = presents.indexOf(present);
            if (index > -1) {
                presents.splice(index, 1);
            }
        }
    }
}

function resetSnowball(snowball) {
    // Reset logic
    snowball.position.x = Math.random() * 10 + 15;
    snowball.position.y = Math.random() * 4.5 - 1.25;
    snowball.userData.speed = Math.random() * 0.05 + 0.02;
}